import React, { useState } from "react";
import apiRoutes from "../../../api/apiRoutes";
import { appFetchBlob } from "../../../utils/http";
import BtnGuardar from "../../../components/buttons/BtnGuardar";

import EessAutocomplete from "../../../components/autocomplete/EessAutocomplete";
import ProductoAutocomplete from "../../../components/autocomplete/ProductoAutocomplete";
import LiquidacionEjecucionAutocomplete from "../../../components/autocomplete/LiquidacionEjecucionAutocomplete";

const FORMATO_OPCIONES = [
  { id: "PDF", label: "PDF" },
  { id: "EXCEL", label: "EXCEL" },
];

export default function ReporteAcreditacionEess() {
  const [descargando, setDescargando] = useState(false);

  const [eess, setEess] = useState(null);
  const [producto, setProducto] = useState(null);
  const [liqDesde, setLiqDesde] = useState(null);
  const [liqHasta, setLiqHasta] = useState(null);

  const [fechaDesde, setFechaDesde] = useState("");
  const [fechaHasta, setFechaHasta] = useState("");
  const [formato, setFormato] = useState("PDF");

  const handleConsultar = async () => {
  if (!formato) {
    alert("Seleccione un formato");
    return;
  }

  try {
    const params = new URLSearchParams();

    if (eess?.id) params.append("eessId", eess.id);
    if (producto?.id) params.append("productoId", producto.id);
    if (liqDesde?.id) params.append("liquidacionDesdeId", liqDesde.id);
    if (liqHasta?.id) params.append("liquidacionHastaId", liqHasta.id);
    if (fechaDesde) params.append("fechaDesde", fechaDesde);
    if (fechaHasta) params.append("fechaHasta", fechaHasta);

    params.append("formato", formato);

    const url = apiRoutes.liquidacionEess.exportar(params);

    const { blob, filename } = await appFetchBlob(
      url,
      { method: "GET" },
      { showLoading: true }
    );

    const downloadUrl = window.URL.createObjectURL(blob);

    const a = document.createElement("a");

    const timestamp = new Date()
      .toISOString()
      .slice(0, 19)
      .replace(/[-:T]/g, "");

    const extension = formato === "PDF" ? "pdf" : "xlsx";

    a.href = downloadUrl;
    a.download =
      filename || `Reporte_Acreditacion_EESS_${timestamp}.${extension}`;

    document.body.appendChild(a);
    a.click();
    a.remove();

    window.URL.revokeObjectURL(downloadUrl);
  } catch (error) {
    console.error("Error en descarga:", error);
  }
};


  return (
    <div className="w-full p-6">
      <div className="bg-white border rounded-md shadow-sm">

        {/* HEADER */}
        <div className="px-6 py-4 border-b">
          <h2 className="text-xl font-semibold text-gray-800">
            Introduzca los datos de Liquidacion EE.SS.
          </h2>
        </div>

        {/* BODY */}
        <div className="p-6">
          <div className="bg-gray-100 p-8 rounded-md space-y-5 max-w-4xl mx-auto">

            {/* EE.SS. */}
            <div className="flex items-center">
              <label className="w-48 shrink-0 font-bold text-gray-700">
                EE.SS.:
              </label>
              <div className="w-full max-w-[500px]">
                <EessAutocomplete
                  value={eess}
                  onChange={setEess}
                />
              </div>
            </div>

            {/* PRODUCTO */}
            <div className="flex items-center">
              <label className="w-48 shrink-0 font-bold text-gray-700">
                Producto:
              </label>
              <div className="w-full max-w-[500px]">
                <ProductoAutocomplete
                  value={producto}
                  onChange={setProducto}
                />
              </div>
            </div>

            {/* FECHA DESDE */}
            <div className="flex items-center">
              <label className="w-48 shrink-0 font-bold text-gray-700">
                Fecha Desde:
              </label>
              <input
                type="date"
                value={fechaDesde}
                onChange={(e) => setFechaDesde(e.target.value)}
                className="input w-full max-w-[500px]"
              />
            </div>

            {/* FECHA HASTA */}
            <div className="flex items-center">
              <label className="w-48 shrink-0 font-bold text-gray-700">
                Fecha Hasta:
              </label>
              <input
                type="date"
                value={fechaHasta}
                onChange={(e) => setFechaHasta(e.target.value)}
                className="input w-full max-w-[500px]"
              />
            </div>

            {/* LIQUIDACION DESDE */}
            <div className="flex items-center">
              <label className="w-48 shrink-0 font-bold text-gray-700">
                Liquidacion Desde:
              </label>
              <div className="w-full max-w-[500px]">
                <LiquidacionEjecucionAutocomplete
                  value={liqDesde}
                  onChange={setLiqDesde}
                />
              </div>
            </div>

            {/* LIQUIDACION HASTA */}
            <div className="flex items-center">
              <label className="w-48 shrink-0 font-bold text-gray-700">
                Liquidacion Hasta:
              </label>
              <div className="w-full max-w-[500px]">
                <LiquidacionEjecucionAutocomplete
                  value={liqHasta}
                  onChange={setLiqHasta}
                />
              </div>
            </div>

            {/* FORMATO */}
            <div className="flex items-center">
              <label className="w-48 shrink-0 font-bold text-gray-700">
                Formato:
              </label>
              <select
                value={formato}
                onChange={(e) => setFormato(e.target.value)}
                className="input w-full max-w-[500px]"
              >
                {FORMATO_OPCIONES.map((op) => (
                  <option key={op.id} value={op.id}>
                    {op.label}
                  </option>
                ))}
              </select>
            </div>

          </div>
        </div>

        {/* FOOTER */}
        <div className="px-6 py-4 border-t bg-gray-50 flex justify-start">
          <BtnGuardar
            label="Consultar"
            saving={descargando}
            isValid={true}
            onClick={handleConsultar}
          />
        </div>

      </div>
    </div>
  );
}
